import GoodsModule from '../Goods'
import SettingTypes from '@/utils/setting-types'

const settings = Object.assign({}, GoodsModule.settings)
delete settings.goodsList

export default {
  name: 'goods-group',
  decor_type: 'admin,seller',
  label: {
    title: '商品分组',
    icon: require('@/assets/icon-component-label_Goods.png'),
    limit: 20
  },
  sort: 2.2,
  data: Object.assign({}, GoodsModule.data, {
    filter_enabled: false,
    group_id: '',
    group_ids: [],
    groups: [],
    group_name: '',
    goodsList: []
  }),
  settings: Object.assign({
    filter_enabled: {
      type: SettingTypes.boolean,
      label: '商品筛选',
      props: { activeText: '开启', inactiveText: '关闭' }
    },
    group_ids: {
      type: SettingTypes.custom,
      component_name: 'GoodsGroupSettingSelector',
      space_line: true
    }
  }, settings)
}
